/* eslint max-len: 0 */
import React from 'react'
import { connect } from 'react-redux'
import { string } from 'prop-types'

import { getRegion } from 'models/location/selectors'
import { getPolicies } from 'privacyPolicies'

import * as pageOptions from 'constants/pageOptions'

require('./PrivacyPolicyPage.scss')

const PrivacyPolicyPage = ({ page, region }) => {
    const policies = getPolicies(region)
    if (page === pageOptions.PRIVACY) {
        return (
            <div id="PrivacyPolicyPage">
                <div className="policyContainer">{policies.privacy}</div>
            </div>
        )
    }
    return (
        <div id="PrivacyPolicyPage">
            <div className="policyContainer">{policies.terms}</div>
        </div>
    )
}

PrivacyPolicyPage.propTypes = {
    page: string.isRequired,
    region: string.isRequired,
}

const mapStateToProps = (state) => ({
    region: getRegion(state),
})

export default connect(mapStateToProps)(PrivacyPolicyPage)
